export enum HomeButtonClickEventName {
  RUN_DIAGNOSE = "RUN_DIAGNOSE",
  RERUN_DIAGNOSYS = "RERUN_DIAGNOSYS",
  QUINCY_VIEW_MORE = "QUINCY_VIEW_MORE",
  QUINCY_NEXT_MOVE = "QUINCY_NEXT_MOVE",
  ADVANCE_VIEW_MORE = "ADVANCE_VIEW_MORE",
  GOALS_VIEW_MORE = "GOALS_VIEW_MORE",
  GOALS_INTERACTION = "GOALS_INTERACTION",
  BOOST_SPOTIFY_FOLLOWERS = "BOOST_SPOTIFY_FOLLOWERS",
  BOOST_SPOTIFY_POPULARITY = "BOOST_SPOTIFY_POPULARITY",
  BREAKING_SOUND_SUBMIT = "BREAKING_SOUND_SUBMIT",
}

export enum LoginButtonClickEventName {
  LOGIN_GOOGLE = "LOGIN_GOOGLE",
  LOGIN_FACEBOOK = "LOGIN_FACEBOOK",
  SIGN_IN = "SIGN_IN",
  RECOVERY_PASSWORD = "RECOVERY_PASSWORD",
  SIGN_UP = "SIGN_UP",
}

export enum QuizButtonClickEventName {
  SEARCH_SPOTIFY_PROFILE = "SEARCH_SPOTIFY_PROFILE",
  SEARCH_YOUTUBE_PROFILE = "SEARCH_YOUTUBE_PROFILE",
  SEARCH_INSTAGRAM_PROFILE = "SEARCH_INSTAGRAM_PROFILE",
  NEXT = "NEXT",
}

export enum SignUpButtonClickEventName {
  LOGIN = "LOGIN",
  LOGIN_GOOGLE = "LOGIN_GOOGLE",
  LOGIN_FACEBOOK = "LOGIN_FACEBOOK",
  RESEND_CODE = "RESEND_CODE",
  VERIFY_CODE = "VERIFY_CODE",
  REGISTER = "REGISTER",
}

export enum AdvanceButtonClickEventName {
  REQUEST = "REQUEST",
  NEXT = "NEXT",
}

export enum DistroButtonClickEventName {
  SIGN_CONTRACT = "SIGN_CONTRACT",
  NEXT = "NEXT",
}

export enum QuincyButtonClickEventName {
  QUINCY_LIKE = "QUINCY_LIKE",
  QUINCY_DISLIKE = "QUINCY_DISLIKE",
  QUINCY_COPY = "QUINCY_COPY",
  QUINCY_REGENERATE = "QUINCY_REGENERATE",
  QUINCY_SEARCH = "QUINCY_SEARCH",
}

export enum MenuButtonClickEventName {
  SONGTOOLS_MENU_CTA = "SONGTOOLS_MENU_CTA",
  OPEN_MENU = "OPEN_MENU",
  PROFILE = "PROFILE",
  HOME = "HOME",
  QUINCY = "QUINCY",
  GOALS = "GOALS",
  ASSESSMENT = "ASSESSMENT",
  DISTRIBUTION = "DISTRIBUTION",
  ADVANCES = "ADVANCES",
  PITCHING = "PITCHING",
  RELEASES = "RELEASES",
  CONNECTIONS = "CONNECTIONS",
  STRM_CLASS = "STRM_CLASS",
  LEVEL = "LEVEL",
  TOURING = "TOURING",
}

export enum GoalsButtonClickEventName {
  BOOST_SPOTIFY_FOLLOWERS = "BOOST_SPOTIFY_FOLLOWERS",
  BOOST_SPOTIFY_POPULARITY = "BOOST_SPOTIFY_POPULARITY",
}

export enum PricingButtonClickEventName {
  FREE_PLAN = "FREE_PLAN",
  PREMIUM_TRIAL_START = "PREMIUM_TRIAL_START",
  PREMIUM_START = "PREMIUM_START",
  DISTRIBUTION_PLAN = "DISTRIBUTION_PLAN",
  LABEL_PLAN = "LABEL_PLAN",
  START_LABEL_PLAN = "START_LABEL_PLAN",
  START_DISTRIBUTION_PLAN = "START_DISTRIBUTION_PLAN",
}
